export enum GtmEvents {
    Session = "Session",
    Role = "Role",
}

export default GtmEvents;
